<template>
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.150391" width="15" height="15.6977" rx="1.77778" fill="#005DAD" fill-opacity="0.9"/>
        <rect x="1.0306" y="1.18294" width="12.938" height="13.6357" rx="1" stroke="white" stroke-width="0.666667"/>
        <path d="M3.83691 13.0577V2.94141H8.28467C9.25335 2.94141 10.0356 3.25651 10.6313 3.88672C11.218 4.52163 11.5113 5.3188 11.5113 6.27823C11.5113 7.26587 11.218 8.07715 10.6313 8.71206C10.0356 9.35638 9.25335 9.67854 8.28467 9.67854H6.0335V13.0577H3.83691ZM6.0335 7.65387H7.84808C8.79857 7.65387 9.27381 7.19532 9.27381 6.27823C9.27381 5.84555 9.14875 5.51398 8.89862 5.28353C8.64394 5.06249 8.29376 4.95196 7.84808 4.95196H6.0335V7.65387Z" fill="white"/>
    </svg>
</template>
<script>
const parkingDetailsIcon = {
    name: 'parkingDetailsIcon',
}
export default parkingDetailsIcon
export { parkingDetailsIcon }
</script>
